import { render, staticRenderFns } from "./DevelopmentProcessSection.vue?vue&type=template&id=4d565800&"
import script from "./DevelopmentProcessSection.vue?vue&type=script&lang=js&"
export * from "./DevelopmentProcessSection.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentProcessSection.vue?vue&type=style&index=0&id=4d565800&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports